export enum ProspectActions {
  SEARCH_AGGREGATED_PROSPECTS = 'SEARCH_AGGREGATED_PROSPECTS',
  GET_PROSPECT_PORTFOLIOS = 'GET_PROSPECT_PORTFOLIOS',
  CLEAR_PROSPECT_STATE = 'CLEAR_PROSPECT_STATE',
  GET_PROSPECT_DETAILS = 'GET_PROSPECT_DETAILS',
  DELETE_PROSPECT = 'DELETE_PROSPECT',
  DELETE_PROSPECT_PORTFOLIO = 'DELETE_PROSPECT_PORTFOLIO',
  CREATE_PROSPECT = 'CREATE_PROSPECT',
  CREATE_PROSPECT_PORTFOLIO = 'CREATE_PROSPECT_PORTFOLIO',
}
